const PIXEL_ID = '1012782631449952'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

/**
 * Inyecta el código base oficial del Meta Pixel y dispara un evento PageView.
 * Es idempotente: si ya se inicializó, no vuelve a inyectar el script.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) {
    // ya inicializado: solo registramos la vista de página
    window.fbq('track', 'PageView')
    return
  }

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    let n: any
    let t: HTMLScriptElement
    let s: HTMLScriptElement
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0] as HTMLScriptElement
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}
